import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Save, Plus, X } from "lucide-react";
import { ImageUpload } from "@/components/ImageUpload";

export default function AdminHome() {
  const [data, setData] = useState({ hero_title: "", hero_subtitle: "", hero_image: "", why_us: [], process_steps: [] });
  useEffect(() => {
    api.get("/home-content").then((r) => setData({ hero_title: "", hero_subtitle: "", hero_image: "", why_us: [], process_steps: [], ...r.data }));
  }, []);

  const save = async () => {
    // strip _ck client keys
    const payload = {
      ...data,
      why_us: (data.why_us || []).map(({ _ck, ...rest }) => rest),
      process_steps: (data.process_steps || []).map(({ _ck, ...rest }) => rest),
    };
    try { await api.put("/home-content", payload); toast.success("Kaydedildi"); }
    catch { toast.error("Hata"); }
  };

  const upd = (k, v) => setData({ ...data, [k]: v });
  const updArr = (key, i, patch) => {
    const arr = [...(data[key] || [])];
    arr[i] = { ...arr[i], ...patch };
    setData({ ...data, [key]: arr });
  };
  const addWhy = () => upd("why_us", [...(data.why_us || []), { icon: "sparkles", title: "", description: "", _ck: crypto.randomUUID() }]);
  const rmWhy = (i) => upd("why_us", data.why_us.filter((_, x) => x !== i));
  const addStep = () => upd("process_steps", [...(data.process_steps || []), { step: (data.process_steps?.length || 0) + 1, title: "", description: "", _ck: crypto.randomUUID() }]);
  const rmStep = (i) => upd("process_steps", data.process_steps.filter((_, x) => x !== i));

  return (
    <div data-testid="admin-home">
      <h1 className="font-display text-3xl md:text-4xl font-black text-ink-900 mb-8">Ana Sayfa İçeriği</h1>
      <div className="space-y-6 max-w-3xl">
        <div className="rounded-3xl bg-white border border-ink-100 p-6 space-y-4">
          <h3 className="font-display font-bold text-xl">Hero</h3>
          <div><Label>Başlık</Label><Input value={data.hero_title} onChange={(e) => upd("hero_title", e.target.value)} className="mt-1.5" /></div>
          <div><Label>Alt Metin</Label><Textarea rows={3} value={data.hero_subtitle} onChange={(e) => upd("hero_subtitle", e.target.value)} className="mt-1.5" /></div>
          <ImageUpload
            value={data.hero_image || ""}
            onChange={(url) => upd("hero_image", url)}
            label="Hero Görseli"
            testId="hero-image"
          />
        </div>

        <div className="rounded-3xl bg-white border border-ink-100 p-6 space-y-3">
          <div className="flex items-center justify-between"><h3 className="font-display font-bold text-xl">Neden Biz Kartları</h3>
            <Button variant="outline" onClick={addWhy} className="rounded-full text-xs"><Plus className="h-3 w-3 mr-1" /> Ekle</Button>
          </div>
          {(data.why_us || []).map((w, i) => (
            <div key={w._ck || `why-existing-${i}`} className="rounded-xl border border-ink-100 p-3 space-y-2">
              <div className="flex gap-2 items-center">
                <Input placeholder="ikon (ruler/zap/award/shield-check/truck/message-circle)" value={w.icon} onChange={(e) => updArr("why_us", i, { icon: e.target.value })} />
                <Button variant="outline" onClick={() => rmWhy(i)} className="rounded-full"><X className="h-4 w-4" /></Button>
              </div>
              <Input placeholder="başlık" value={w.title} onChange={(e) => updArr("why_us", i, { title: e.target.value })} />
              <Input placeholder="açıklama" value={w.description} onChange={(e) => updArr("why_us", i, { description: e.target.value })} />
            </div>
          ))}
        </div>

        <div className="rounded-3xl bg-white border border-ink-100 p-6 space-y-3">
          <div className="flex items-center justify-between"><h3 className="font-display font-bold text-xl">Süreç Adımları</h3>
            <Button variant="outline" onClick={addStep} className="rounded-full text-xs"><Plus className="h-3 w-3 mr-1" /> Ekle</Button>
          </div>
          {(data.process_steps || []).map((s, i) => (
            <div key={s._ck || `step-existing-${i}`} className="rounded-xl border border-ink-100 p-3 space-y-2">
              <div className="flex gap-2 items-center">
                <Input type="number" placeholder="adım" value={s.step} onChange={(e) => updArr("process_steps", i, { step: Number(e.target.value) })} className="w-20" />
                <Input placeholder="başlık" value={s.title} onChange={(e) => updArr("process_steps", i, { title: e.target.value })} />
                <Button variant="outline" onClick={() => rmStep(i)} className="rounded-full"><X className="h-4 w-4" /></Button>
              </div>
              <Input placeholder="açıklama" value={s.description} onChange={(e) => updArr("process_steps", i, { description: e.target.value })} />
            </div>
          ))}
        </div>

        <Button onClick={save} className="gradient-primary text-white rounded-full"><Save className="h-4 w-4 mr-1.5" /> Kaydet</Button>
      </div>
    </div>
  );
}
